export { default as MailOutlineIcon } from './MailOutlineIcon';
